const DEV_TOOLS = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
export default DEV_TOOLS;